import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { withTranslation } from 'react-i18next'

import { Event } from '../../../../../../entities/Event'

import './EventHeader.css'

export const EventHeader = ({ t, event: { title, category, backgroundColor } }) => (
    <div className="event-header">
        <Link to={t('eventDetails.allEvents.link')} className="event-header__all-events-link">
            {/* <div className="event-header__all-events-link__arrow">
                <div className="event-header__all-events-link__arrow__arrow" />
                <div className="event-header__all-events-link__arrow__line" />
            </div>
            <div className="event-header__all-events-link__text">
                {t('eventDetails.allEvents.linkText')}
            </div> */}
        </Link>
        <div className="event-header__label" style={{ backgroundColor: backgroundColor }}>
            {category.name}
        </div>
        <h4>{title}</h4>
    </div>
)

EventHeader.propTypes = {
    event: PropTypes.instanceOf(Event).isRequired
}

export default withTranslation()(EventHeader)
